import { languages } from '../plugins/i18n'

export default {
  namespaced: true,
  state:{
    user: null,
    parentCompany: null,
    controlNavigation: false,
    defaultPageGroups: []
  },
  mutations: {
    /***
     * @desc update the navigation state
     * @param state
     */
    controlNavigationChange (state) {
      state.controlNavigation = !state.controlNavigation
    },
    /***
       * @desc to assign current logged-in user to local store. The permissions are assigned from ac_granted_permissions list
       * @param state
       * @param payload
       */
    user(state, payload) {
      state.user = payload
    },

    /**
     * @desc to assign all page group from backend to frontend
     * @param state
     * @param payload
     */
    defaultPageGroups(state, payload) {
      state.defaultPageGroups = payload
    },

    /***
     * @desc to store current parent company
     * @param state
     * @param payload
     */
    parentCompany(state, payload) {
      state.parentCompany = payload
    },

    /***
       * @desc to set local lang
       * @param state
       * @param payload
       */
    localLang(state, payload) {
      if(languages.map(x => x.locale).includes(payload)) {
        window.sessionStorage.setItem('local_lang', payload)
      }
    }
  },
  getters: {
    /***
     * @desc to compute navigation group
     * @returns {[{route: {name: string}, icon: string, title: string, isShow: boolean},{route: {name: string}, icon: string, title: string, isShow: boolean},{icon: string, href: string, title: string, isShow: boolean}]}
     */
    navGroups(state, getters) {
      return [
        {
          title: 'home_page',
          icon: 'mdi-home',
          route: { name: 'Home' },
          isShow: state.defaultPageGroups.find(x => x.active && x.route === 'home') &&
            (getters['pageAccess'].includes('home') || getters['primaryAccount'])
        },
        {
          title: 'employee',
          icon: 'mdi-human-queue',
          route: { name: 'EmployeeList' },
          isShow: state.defaultPageGroups.find(x => x.active && x.route === 'employees') &&
            (getters['pageAccess'].includes('employees') || getters['primaryAccount'])
        },
        {
          title: 'employee_seminar_info',
          icon: 'mdi-table-account',
          route: { name: 'EmployeeSeminarInfo' },
          isShow: state.defaultPageGroups.find(x => x.active && x.route === 'employee-seminar-info') &&
            (getters['pageAccess'].includes('employee-seminar-info') || getters['primaryAccount'])
        },
        {
          title: 'user_group',
          icon: 'mdi-account-group',
          route: { name: 'Group' },
          isShow: state.defaultPageGroups.find(x => x.active && x.route === 'group') &&
            (getters['pageAccess'].includes('group') || getters['primaryAccount'])
        },
        {
          title: 'login_account',
          icon: 'mdi-account-wrench',
          route: { name: 'ManageAccount' },
          isShow: state.defaultPageGroups.find(x => x.active && x.route === 'login-account') &&
            (getters['pageAccess'].includes('login-account') || getters['primaryAccount'])
        },
        {
          title: 'course_report',
          icon: 'mdi-clipboard-list',
          route: { name: 'CourseReport' },
          isShow: state.defaultPageGroups.find(x => x.active && x.route === 'login-account') &&
            (getters['pageAccess'].includes('employee-course-report') || getters['primaryAccount'])
        },
        {
          title: 'manual',
          icon: 'mdi-book-open-variant',
          href: '/manual/operationmanual.pdf',
          isShow: true
        }
      ]
    },

    primaryAccount(state) {
      return state.user.is_primary_login_account
    },

    /***
     * @desc to correctly return user
     * @param state
     * @returns {null}
     */
    user(state) {
      return state.user || null
    },

    /***
     * @desc generate the array of page that logged-in user can access to
     * @param state
     * @returns {*[]}
     */
    pageAccess(state) {
      if (state.user && state.user.user_group?.page_groups) {
        const pages = []
        state.user.user_group.page_groups.forEach(x => {
          pages.push(x.route)
        })
        return pages
      } else {
        return []
      }
    },

    /***
     * @desc to return correct user id for the user without exception
     * @param state
     * @returns {string|*}
     */
    name(state) {
      if(!state.user) {
        return 'Guest'
      } else {
        return state.user.id
      }
    },


    /***
     * @desc to get the local lang setting
     * @returns {string|string}
     */
    localLang() {
      const localLang = window.sessionStorage.getItem('local_lang')
      return localLang || 'jp'
    },
  }
}
